import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {ColaboradorPuesto} from '@modelo/catalogo/ColaboradorPuesto.model';

@Component(
    {
        selector: 'colaborador_puesto',
        templateUrl: './colaborador_puesto.template.html',
        styleUrls: ['../colaborador.component.scss']
    })

export class ColaboradorPuestoComponent implements OnInit {
    @Input() id!: number;
    @Input() disabled!: boolean;

    public entidad: ColaboradorPuesto;

    SelPuesto: any[];

    public abierto!: boolean;
    public animacion!: string;
    public errorActivo!: boolean;

    dataTable: Array<any>;
    dataTable2: Array<any>;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new ColaboradorPuesto();

        this.SelPuesto = [];

        this.dataTable = [];
        this.dataTable2 = [];
    }

    ngOnInit() {
        this.setPuesto();

        this.Buscar();
    }


    setPuesto() {
        this.appService.Post("configuracionrh/puesto/buscar", {activo: true}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelPuesto = res.data
            }
        });
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.errorActivo = false;
    }

    CerrarModal() {
        this.entidad = new ColaboradorPuesto();
        this.animacion = this.sistemaService.animacionCerrarModal;

        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Guardar(): Promise<any> {
        return new Promise((resolve, reject) => {
            let respuesta = this.Validar();
            if (respuesta != true) {
                return this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
            }

            let data = new ColaboradorPuesto(this.entidad);
            this.appService.Post("configuracionrh/colaborador/puesto/" + this.id, data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.CerrarModal();
                    this.Buscar();
                }
            })
        })
    }

    Validar(): any {
        this.errorActivo = true;
        if (!this.entidad.puestoid.length) {
            return "Ingrese mínimo un puesto";
        }
        if (!this.entidad.fechaasignado || !this.entidad.fechaasignado.trim()) {
            return "Ingrese una fecha de asignación";
        }

        let result = this.dataTable.find(o1 => this.entidad.puestoid.some(o2 => o1.puestoid === o2));
        if (result) {
            return "El puesto " + result.puesto + " ya se encuentra registrado";
        }

        return true;
    }

    Buscar() {
        this.appService.Get("configuracionrh/colaborador/puesto/" + this.id).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.dataTable = res.data.actual;
                this.dataTable2 = res.data.historial;
            }
        })
    }

    Baja(e: ColaboradorPuesto) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        opciones[0].Titulo = "Baja"
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres dar de baja el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Put("configuracionrh/colaborador/puesto/" + e.puestoporcolaboradorid, {visibleorganigrama:true}).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.Buscar();
                    }
                })
            }
        })
    }


    Eliminar(e: ColaboradorPuesto) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracionrh/colaborador/puesto/" + e.puestoporcolaboradorid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.Buscar();
                    }
                })
            }
        })
    }

}
